import {normalizeInstitutionType} from '../config/institutionTypes';

export function studentPlacementRows(student={},settings={}){
  const type=normalizeInstitutionType(settings.institutionType||settings.type);
  const rows=[];
  if(type==='school'){
    rows.push(['Class',student.courseIdName||student.className],['Section',student.batchIdName||student.sectionName],['Roll No.',student.rollNo],['Session',student.academicYear||settings.academicYear]);
  }else if(type==='college'){
    rows.push(['Course',student.courseIdName],['Branch',student.branchIdName||student.department],['Semester',student.semester],['Batch',student.batchIdName],['Session',student.academicYear||settings.academicYear]);
  }else if(type==='nursing'){
    rows.push(['Course',student.courseIdName],['Semester / Year',student.semester||student.academicLevel],['Batch',student.batchIdName],['Clinical Batch',student.clinicalBatchName||student.clinicalBatchId],['Session',student.academicYear||settings.academicYear]);
  }else{
    rows.push(['Course',student.courseIdName],['Batch',student.batchIdName],['Batch Timing',student.preferredTiming||student.batchTiming],['Target Exam',student.targetExam],['Session',student.academicYear||settings.academicYear]);
  }
  return rows.filter(([,v])=>v!==undefined&&v!==null&&v!=='');
}

export function studentPlacementText(student={},settings={}){
  return studentPlacementRows(student,settings).map(([k,v])=>`${k}: ${v}`).join(' · ');
}
